<template>
  <div class='details'>
    <div class="YTitle">消息模板详情</div>

    <div class="form">
      <el-form :label-width='`${ 200 / 192 }rem`'>
        <el-form-item label="消息标题：">{{DetailsValue.notifyTitle}}</el-form-item>
        <el-form-item label="是否添加短信模板：">{{DetailsValue.isAddSmsTemplate.name}}</el-form-item>
        <el-form-item label="消息类型：">{{DetailsValue.notifyType.name}}</el-form-item>
        <el-form-item label="模板内容类型：">{{DetailsValue.templateType.name}}</el-form-item>
        <el-form-item label="消息模板：">
          <div v-html="DetailsValue.templateValue"></div>
        </el-form-item>
      </el-form>
    </div>

    <div class="btn">
      <el-button type="primary" round @click="close">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Details',

  props: {
    DetailsValue: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {}
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {},

    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang='stylus' scoped>
  .details
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background #ffffff
    z-index 1
    display flex
    flex-direction column
    .form
      flex auto
      margin-top 20px
    .btn
      margin 20px 0
      text-align center
</style>
